
export const Footer = () => {
    return (
        <div className="text-white text-[1rem] md:text-xl font-normal text-center py-6 bg-[#313131] absolute left-0 bottom-0 w-full">
            created with love by <span className="font-semibold capitalize text-[#f27121] mx-2">-beloued-</span> in 2024
        </div>
    )
}